import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/metaPixel";

/**
 * Fires Meta Pixel `PageView` on every meaningful route change.
 *
 * Why this is needed: in a SPA, the static pixel snippet only sees the
 * initial document load — subsequent `<Link>` navigations don't reload
 * the page, so Meta would massively under-count page views. We listen
 * to react-router's `useLocation` and emit a PageView each time the
 * pathname changes. Query/hash changes are ignored to avoid noise
 * from filter/modal-state URL params.
 *
 * Renders nothing; mounted once inside <BrowserRouter> in App.js.
 */
export default function MetaPixelRouteTracker() {
  const location = useLocation();
  const previousPathRef = useRef(null);

  useEffect(() => {
    const current = location.pathname;
    if (previousPathRef.current === current) return;
    previousPathRef.current = current;
    trackPageView();
  }, [location.pathname, location.search]);

  return null;
}
